export default "__VITE_ASSET__1fc9ae6c__"